import { useCallback, useEffect, useMemo, useState } from 'react'

export const useWindowSize = () => {
  const [size, setSize] = useState({ width: 0, height: 0 })

  const [width, setWidth] = useState(0)
  const [height, setHeight] = useState(0)

  const [isUltrawide, setIsUltrawide] = useState(false)
  const ultraHeight = 'h-[calc(100vw/2.3)]'

  const updateSize = () => {
    const measures = { width: window.innerWidth, height: window.innerHeight }

    setSize(measures)

    if (width !== measures.width) {
      setWidth(measures.width)
    }

    if (height !== measures.height) {
      setHeight(measures.height)
    }

    if (measures.width / measures.height > 2.3) {
      setIsUltrawide(true)
    } else {
      setIsUltrawide(false)
    }
  }

  useEffect(() => {
    window.addEventListener('resize', updateSize)
    updateSize()
    return () => window.removeEventListener('resize', updateSize)
  }, [])

  const breakPoint = useMemo((): 'sm' | 'md' | 'lg' | 'xl' | '2xl' => {
    if (size.width) {
      if (size.width < 768) {
        return 'sm'
      }
      if (size.width < 1024) {
        return 'md'
      }
      if (size.width < 1280) {
        return 'lg'
      }
      if (size.width < 1536) {
        return 'xl'
      }

      return '2xl'
    } else {
      return '2xl'
    }
  }, [size?.width])

  //* This function returns the current breakpoint based in tailwind  default breakpoints
  const getCurrentBreakPoint = useCallback(():
    | 'sm'
    | 'md'
    | 'lg'
    | 'xl'
    | '2xl' => {
    if (size.width < 768) {
      return 'sm'
    }

    if (size.width >= 768 && size.width < 1024) {
      return 'md'
    }

    if (size.width >= 1024 && size.width < 1280) {
      return 'lg'
    }

    if (size.width >= 1280 && size.width < 1536) {
      return 'xl'
    }
    return '2xl'
  }, [size])

  return {
    width,
    height,
    size,
    isUltrawide,
    ultraHeight,
    breakPoint,
    getCurrentBreakPoint,
  }
}

/*
 pantalla comun no ultra 15;9, 16:10 o 16:9
 pantalla ultrawide 21:9
*/
